<!-- Button -->
<button mat-icon-button [matTooltip]="tooltip || 'ขยายเต็มหน้าจอ'" matTooltipPosition="above" (click)="toggleFullscreen()" style="height: 40px !important">
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <i class="ti ti-arrows-maximize" style="color: #fff;"></i>
    <!-- <mat-icon style="color: #fff;" [svgIcon]="'heroicons_outline:arrows-expand'"></mat-icon> -->
</ng-template>